import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { FormControlInput } from "../../../../components/organisms/Form/control";
import { ButtonT1 } from "../../../../components/atoms/Button/Button";
import { ManageGeneralFormProvider } from "../../../../components/organisms/Provider/ManageGeneralFormProvider";
import { FormCard, FormTitle, ErrorMessage, BackLink } from "../index.styles";
import { usePortalLoginMutation } from "../../../../store/apiSlice/portalAuthApiSlice";
import { portalLoginSuccess } from "../../../../store/slice/portalAuthSlice";
import { selectPortalId } from "../../../../store/slice/portalContextSlice";

const LoginForm = () => {
  const [error, setError] = useState("");
  const { subdomain } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const portalId = useSelector(state => selectPortalId(state, subdomain));
  const [portalLogin, { isLoading }] = usePortalLoginMutation();

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().email("Invalid email address").required("Email is required"),
      password: Yup.string().required("Password is required"),
    }),
    onSubmit: async values => {
      setError("");
      try {
        const result = await portalLogin({
          email: values.email,
          password: values.password,
          portal_id: portalId,
        }).unwrap();

        dispatch(
          portalLoginSuccess({
            subdomain,
            accessToken: result.portal_access_token,
            user: result.user,
            customerContact: result.customer_contact,
            salesRep: result.sales_rep,
            portalId,
            currency: result.currency,
            paymentTerm: result.payment_term,
            decimalPrecision: result.decimal_precision,
            portalConfig: result.portal_config,
          }),
        );

        navigate(`/portal/${subdomain}/catalog`);
      } catch (err) {
        setError("Invalid email or password. Please try again.");
      }
    },
  });

  return (
    <FormCard>
      <FormTitle>Sign in</FormTitle>
      <ManageGeneralFormProvider formik={formik}>
        <form onSubmit={formik.handleSubmit}>
          <div className="mb-7">
            <FormControlInput
              name="email"
              type="email"
              label="Email"
              placeholder="Email"
              variant="light"
              context="general"
              required
            />
          </div>

          <div className="mb-7">
            <FormControlInput
              name="password"
              type="password"
              label="Password"
              placeholder="Password"
              variant="light"
              context="general"
              required
            />
          </div>

          <div className="mb-7">
            <ButtonT1
              title={isLoading ? "Signing in..." : "Sign in"}
              loading={isLoading}
              disabled={isLoading}
              type="submit"
              $variant="primary"
              $width="100%"
            />
          </div>
        </form>
      </ManageGeneralFormProvider>
      {error && <ErrorMessage>{error}</ErrorMessage>}
      <BackLink onClick={() => navigate(`/portal/${subdomain}/auth/forgot_password`)}>
        Forgot your password?
      </BackLink>
    </FormCard>
  );
};

export default LoginForm;
